import axios from "~/plugins/axios";

export default {
  view(viewName) {
    return axios.get(`/dashboard/panel/${viewName}`)
      .then((response) => response.data);
  },
};
